import { activityLog } from "@/features/activityLog";
import {
    productItem,
    trackBeginCheckout,
    trackCheckoutError,
    trackCheckoutRedirect,
    trackSelectItem,
    trackViewItemList,
    usd,
    type CheckoutInfo,
} from "@/shared/lib/analytics";
import type { PlanOffer } from "../api/supPlanApi";

/**
 * GA4 пакетов — те же id, что у сервера (sup_plan.product_id): sup-plan-{m}m.
 * Категория — «sup_tokens», как у прежних пакетов умного поиска: отчёты о
 * продажах поиска остаются одной строкой.
 */
export const PLAN_LIST_ID = "sup_plans";

export const planItemId = (months: number) => `sup-plan-${months}m`;

const itemOf = (o: PlanOffer) =>
    productItem(planItemId(o.months), `SUP plan ${o.months} mo · ${o.questions} questions`, "sup_tokens", usd(o.cents));

export const trackPlanList = (offers: PlanOffer[], place: string): void => {
    trackViewItemList(PLAN_LIST_ID, offers.map(itemOf), { cta_location: place });
    activityLog.track("plan_view", { place, n: offers.length });
};

export const trackPlanSelect = (o: PlanOffer, place: string): void => {
    trackSelectItem(PLAN_LIST_ID, itemOf(o), { cta_location: place });
    activityLog.track("plan_select", { months: o.months, cents: o.cents, place });
};

export const planCheckoutInfo = (o: PlanOffer, place: string): CheckoutInfo => ({
    kind: "sup_tokens",
    items: [itemOf(o)],
    extra: { cta_location: place },
});

export const trackPlanBeginCheckout = (o: PlanOffer, place: string): CheckoutInfo => {
    const c = planCheckoutInfo(o, place);
    trackBeginCheckout(c);
    activityLog.track("checkout_redirect", { kind: "sup_plan", months: o.months, place });
    return c;
};

export const trackPlanRedirect = (c: CheckoutInfo) => trackCheckoutRedirect(c);

export const trackPlanCheckoutError = (o: PlanOffer, err: unknown, place: string): void => {
    trackCheckoutError("sup_tokens", err, { item_id: planItemId(o.months), cta_location: place });
    activityLog.track("checkout_error", { kind: "sup_plan", months: o.months, place });
};
